import { FormProvider } from 'react-hook-form';
import { useCreatePortalModal } from './hooks';
import { CreatePortalModalPresentation } from './presentations';

type Props = {
  isOpen: boolean;
  lastSortOrder?: number;
  onClose: () => void;
};

export const CreatePortalModal: React.FC<Props> = ({ isOpen, lastSortOrder, onClose }) => {
  const {
    state: { methods, selectedFile },
    actions: { handleSubmit, handleFileChange, handleRemoveFile, handleItemTypeChange },
  } = useCreatePortalModal({ lastSortOrder, onClose });

  return (
    <FormProvider {...methods}>
      <CreatePortalModalPresentation
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleSubmit}
        selectedFile={selectedFile}
        onFileChange={handleFileChange}
        onRemoveFile={handleRemoveFile}
        onItemTypeChange={handleItemTypeChange}
      />
    </FormProvider>
  );
};
